import { Link } from "react-router-dom";
import { Users } from "lucide-react";
import { absUrl } from "@/lib/api";
import { useI18n } from "@/i18n/I18nContext";

const Avatar = ({ dev }) => {
  const initials = dev.brand.split(/\s+/).map((w) => w[0]).join("").slice(0, 2).toUpperCase();
  return dev.icon_url ? (
    <img src={absUrl(dev.icon_url)} alt="" className="h-14 w-14 shrink-0 rounded-2xl object-cover ring-1 ring-amber-400/40" data-testid={`developer-avatar-${dev.slug}`} />
  ) : (
    <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-gradient-to-br from-amber-400 to-amber-700 font-display text-lg font-black text-black" data-testid={`developer-initials-${dev.slug}`}>{initials}</span>
  );
};

export const DeveloperDirectory = ({ devs }) => {
  const { t, fmtDownloads } = useI18n();
  if (!devs) return null;
  return (
    <section data-testid="developer-directory">
      <h2 className="mb-4 flex items-center gap-2 font-display text-sm font-bold uppercase tracking-wider text-[var(--gold-bright)] md:text-base">
        <Users className="h-5 w-5" /> {t("market.devsTitle")} <span className="text-amber-300" data-testid="developer-directory-count">({devs.length})</span>
      </h2>
      {devs.length === 0 && <p className="card-carbon rounded-2xl p-5 text-sm text-neutral-400" data-testid="developer-directory-empty">{t("market.noDevs")}</p>}
      <ul className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {devs.map((d) => (
          <li key={d.slug} className="min-w-0">
            <Link to={`/developpeurs/${d.slug}`} className="card-carbon hoverable flex items-center gap-4 rounded-2xl p-4" data-testid={`developer-card-${d.slug}`}>
              <Avatar dev={d} />
              <span className="min-w-0">
                <span className="block truncate font-semibold text-white" data-testid={`developer-card-name-${d.slug}`}>{d.brand}</span>
                <span className="mt-0.5 block text-xs text-neutral-400" data-testid={`developer-card-apps-${d.slug}`}>{t("market.devApps", { n: d.apps_count })}</span>
                <span className="block text-xs font-semibold text-[var(--gold-bright)]" data-testid={`developer-card-downloads-${d.slug}`}>{fmtDownloads(d.downloads)}</span>
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
};
